import { BoardColumnWithLeads } from '../services/responses/board-column.response';
import { LeadResponse } from '../services/responses/lead.response';

/// O que acontece com o lead solto numa das zonas do rodapé.
export type DropAction = 'won' | 'lost' | 'move';

export type CrmDragData =
    | { type: 'lead'; lead: LeadResponse }
    | { type: 'column'; column: BoardColumnWithLeads }
    | { type: 'action'; action: DropAction };

export const dragData = (data: unknown): CrmDragData | null =>
    data && typeof data === 'object' && 'type' in data ? (data as CrmDragData) : null;
